var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoTab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 60,
    fill: "#FF9900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7954 7.45453H51.6363V37.6818C51.6363 41.0757 50.8257 44.0454 49.2045 46.5909C47.5984 49.1363 45.3484 51.1212 42.4545 52.5454C39.5606 53.9545 36.1894 54.6591 32.3409 54.6591C28.4772 54.6591 25.0984 53.9545 22.2045 52.5454C19.3106 51.1212 17.0606 49.1363 15.4545 46.5909C13.8484 44.0454 13.0454 41.0757 13.0454 37.6818V7.45453H22.8863V36.8409C22.8863 38.6136 23.2727 40.1894 24.0454 41.5682C24.8333 42.947 25.9394 44.0303 27.3636 44.8182C28.7878 45.606 30.4469 46 32.3409 46C34.25 46 35.909 45.606 37.3181 44.8182C38.7424 44.0303 39.8409 42.947 40.6136 41.5682C41.4015 40.1894 41.7954 38.6136 41.7954 36.8409V7.45453Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTab);
export default __webpack_public_path__ + "static/media/logoTab.952cd00246d000b077e7a16ae1731fe3.svg";
export { ForwardRef as ReactComponent };